export const INIT = 'MY_SUBJECTS/INIT';

export const GET_DATA_START = 'MY_SUBJECTS/GET_DATA_START';

export const COLUMNS_SAVE_USER_SETUP_START = 'MY_SUBJECTS/COLUMNS_SAVE_USER_SETUP_START';
export const COLUMNS_GET_CONFIG_START = 'MY_SUBJECTS/COLUMNS_GET_CONFIG_START';

export const FILTERS_GET_CONFIG_START = 'MY_SUBJECTS/FILTERS_GET_CONFIG_START';
export const FILTERS_REFRESH_VALUES_START = 'MY_SUBJECTS/FILTERS_REFRESH_VALUES_START';

export const RECORD_GET_DETAILS_START = 'MY_SUBJECTS/RECORD_GET_DETAILS_START';

export const REFRESH_DATA_START = 'MY_SUBJECTS/REFRESH_DATA_START';
export const SYNC_DATA_WITH_CACHE_START = 'MY_SUBJECTS/SYNC_DATA_WITH_CACHE_START';
